if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.setVariantData();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      setVariantData() {
        const loadingSpinner = document.getElementsByClassName('custom-page-fully-loaded-spinner')[0];
        loadingSpinner.parentElement.style.textAlign = 'center';
        loadingSpinner.classList.remove('hidden');
        // hide vendor title for Global Products (Wargame Trader)
        const globalContentLoadingDiv = document.getElementsByClassName('product__info-container')[0];
        const productDescription = document.getElementsByClassName('product__description')[0].innerText.trim();
        
        // If this is a global product, and not a seller-specific one, hide the default add to cart form as they will be adding to cart from the seller table
        if ([...document.getElementsByClassName("wk_global_product")][0].dataset.tags.includes("wk_global") && ![...document.getElementsByClassName("wk_global_product")][0].dataset.tags.includes("se_global")) {
          [...document.getElementsByClassName("product-form")][0].remove();
        } else {
            loadingSpinner.classList.add('hidden');
            loadingSpinner.parentElement.style.textAlign = 'left';
            globalContentLoadingDiv.classList.remove('hidden');
            return;
        }

        const vendorTitleList = [...document.getElementsByClassName("caption-with-letter-spacing")];
        if (vendorTitleList.length > 0 && vendorTitleList[0].innerText === "Wargame Trader") {
            vendorTitleList[0].remove();
        }

        fetch("/browsing_context_suggestions.json")
        .then(response => response.json())
        .then(data => {
          const country = data.detected_values.country.name;
          const countryCode = data.detected_values.country.handle;
          const getSellerProductDataUrl = `https://www.wargametrader.com/search?&q="${productDescription.replace(/ /g, '+').replace(/&/g, "%26")}"&country=${country}`;
          fetch(getSellerProductDataUrl)
            .then((sellerResponse) => sellerResponse.text())
            .then((sellerResponseText) => {
                const sellerProductCards = new DOMParser().parseFromString(sellerResponseText, 'text/html');
                let available_variants = "";
                let totalCardQuantityDataList = [];
                const addToCart = this.addToCart;
                const maxItemsInCart = this.maxItemsInCart;
                const addSellerQuantities = this.addSellerQuantities;
                const processSellerItems = this.processSellerItems;
                const processSellerDiv = this.processSellerDiv;
                const variants = document.querySelectorAll(`div.select option`);
  
                // Get all available variant stock
                let available_variants_array = [];
                let availableCountryForVariants = {};
                const allowedCountries = ["United States", "Canada", "United Kingdom"]
                availableCountryForVariants[allowedCountries[0]] = [];
                availableCountryForVariants[allowedCountries[1]] = [];
                availableCountryForVariants[allowedCountries[2]] = [];

                [...sellerProductCards.getElementsByClassName('card__information')].forEach(card => {
                  const firstAvaliableVariant = card.id;
                  const cardQuantity = card.parentElement.id;

                  let cardQuantityDataList = cardQuantity.split("+++");
                  cardQuantityDataList = cardQuantityDataList.filter(data => data !== "");
                  [...cardQuantityDataList].forEach(cardQuantityData => {
                      cardQuantityData = cardQuantityData.split("---");
                      if (cardQuantityData.length > 0 && cardQuantityData[4]) {
                        availableCountryForVariants[cardQuantityData[4]].push(cardQuantityData[0]);
                      }
                  });
                  if (!available_variants_array.includes(firstAvaliableVariant) && firstAvaliableVariant !== "") {
                    available_variants_array.push(firstAvaliableVariant);
                  }
                });

                if (available_variants_array.length > 0 && available_variants_array[0].includes("+++")) {
                  available_variants_array = available_variants_array[0].split('+++');
                }

                if (!allowedCountries.includes(country) || available_variants_array.length === 0 || availableCountryForVariants[country].length === 0) {
                  // If there's no available variants, set each one to unavailable., hide the div, then return
                  available_variants_array[0] = "Not Available";
                  document.querySelector('variant-selects[id^="variant-selects-template--"]').innerHTML = "<h3>No Listings Available</h3>";
                  loadingSpinner.parentElement.style.textAlign = 'left';
                  const productDiv = document.getElementsByClassName('wk_global_product');
                  if (productDiv.length > 0) {
                    productDiv[0].remove()
                  }
                  const lastSoldListingPlaceholder = document.getElementById("lastSoldListing");
                  if (lastSoldListingPlaceholder) {
                    lastSoldListingPlaceholder.style.display = "block";
                  }

                  const sellProduct = document.getElementById("sellProduct");
                  if (sellProduct) {
                    sellProduct.style.display = "block";
                  }
                  globalContentLoadingDiv.classList.remove('hidden');
                  loadingSpinner.classList.add('hidden');
                  return;
                }

                let firstAvailableVariantOption = document.getElementById("firstAvailableVariantOption");
                if (firstAvailableVariantOption) {
                  firstAvailableVariantOption = firstAvailableVariantOption.innerText;
                }
                let firstAvailableVariantId = document.getElementById("firstAvailableVariantId");
                if (firstAvailableVariantId) {
                  firstAvailableVariantId = firstAvailableVariantId.innerText;
                }

                const setCompletenessOptionHeadings = document.evaluate("//label[@class='form__label' and contains(., 'Set Completeness')]", document, null, XPathResult.ANY_TYPE, null).iterateNext();
                const defaultVariant = setCompletenessOptionHeadings ? "Complete" : "Near Mint";
                // If on page load, there are no Near Mint or Complete listings as is the default, but there are other listings, redirect to the first available condition
                if (available_variants_array.length > 0 && available_variants_array.filter(variant => variant.includes(defaultVariant) && availableCountryForVariants[country].includes(variant)).length === 0 && !window.location.href.includes("variant=")) {
                  if (firstAvailableVariantOption && firstAvailableVariantId && firstAvailableVariantOption !== "Complete/Near Mint" && !window.location.href.includes(firstAvailableVariantId))  {
                    let baseUrl = window.location.href;
                    if (baseUrl.includes("?variant=")) {
                      baseUrl = baseUrl.replace(/\?variant=\d+&?/g, '');
                    }
                    const parameterDelimeter = baseUrl.includes("?") ? "&" : "?";
                    window.location.href = `${baseUrl}${parameterDelimeter}variant=${firstAvailableVariantId}`;
                    return;
                  } else {
                    const setCompletenessVariantToClick = document.querySelectorAll(`div.select option[value="${available_variants_array[0].split(" / ")[0]}"]`)[0];
                    setCompletenessVariantToClick.setAttribute("selected", "selected");
                    setCompletenessVariantToClick.parentElement.dispatchEvent(new Event('change', {'view': window,'bubbles': true}));
                    return;
                  }
                }
  
                let currentSetCompletenessVariant;
                if (setCompletenessOptionHeadings) {
                  currentSetCompletenessVariant = [...setCompletenessOptionHeadings.parentElement.querySelectorAll('div.select option:checked')][0].value;
                  const conditionOptionHeadings = document.evaluate("//label[@class='form__label' and contains(., 'Condition')]", document, null, XPathResult.ANY_TYPE, null).iterateNext();
                  const currentConditionVariant = [...conditionOptionHeadings.parentElement.querySelectorAll('div.select option:checked')][0].value;
                  if (available_variants_array.filter(variant => variant === `${currentSetCompletenessVariant} / ${currentConditionVariant}` && availableCountryForVariants[country].includes(variant)).length === 0 && available_variants_array.filter(variant => variant.includes(currentSetCompletenessVariant)).length > 0) {
                      const conditionVariantToClick = document.querySelectorAll(`div.select option[value="${available_variants_array.filter(variant => variant.includes(currentSetCompletenessVariant))[0].split(" / ")[1]}"]`)[0];
                      conditionVariantToClick.setAttribute("selected", "selected");
                      conditionVariantToClick.parentElement.dispatchEvent(new Event('change', {'view': window,'bubbles': true}));
                      return;
                  }
                }
  
                [...variants].forEach(variant => {
                   if (available_variants_array.filter(availableVariant => (availableVariant.includes(variant.value) && (!setCompletenessOptionHeadings || variant.parentElement.parentElement.parentElement.firstElementChild.innerText.trim() === "Set Completeness" || availableVariant.includes(currentSetCompletenessVariant))) && availableCountryForVariants[country].includes(availableVariant)).length === 0) {
                      variant.classList.add("disabled");
                      variant.setAttribute('style', 'cursor:default !important');
                   } else {
                     variant.classList.remove("disabled");
                     variant.setAttribute('style', 'cursor:pointer !important');
                   }
                });
                [...variants].forEach(variant => {
                  if (variant.classList.contains("disabled")) {
                    variant.remove();
                  } else {
                    variant.innerText = variant.innerText.replace(" - Unavailable", "");
                  }
                });
              
                // If the global product table has loaded
                let table = document.getElementsByTagName("table");
                if (table.length > 0) {
                  processSellerDiv(available_variants, totalCardQuantityDataList, addToCart, maxItemsInCart, addSellerQuantities, processSellerItems, sellerProductCards, loadingSpinner, globalContentLoadingDiv, country);
                } else {
                  // else retry
                  const intervalID = setInterval(function() {
                    table = document.getElementsByTagName("table");
                    if (table.length > 0) {
                        clearInterval(intervalID);
                        processSellerDiv(available_variants, totalCardQuantityDataList, addToCart, maxItemsInCart, addSellerQuantities, processSellerItems, sellerProductCards, loadingSpinner, globalContentLoadingDiv, country);
                    }
                  }, 200);
                }
          });
        }).catch(error => {
            console.error('Error:', error);
        });
      }

      processSellerDiv(available_variants, totalCardQuantityDataList, addToCart, maxItemsInCart, addSellerQuantities, processSellerItems, sellerProductCards, loadingSpinner, globalContentLoadingDiv, country) {
        // Hide the recommended products div if there are no products to display.
        const recommendedProducts = [...document.getElementsByClassName("related-products")][0];
        if (recommendedProducts.lastElementChild && recommendedProducts.lastElementChild.innerText === "") {
          recommendedProducts.remove();
        }
        // Pull current cart items
        fetch("https://www.wargametrader.com" + window.Shopify.routes.root + 'cart.js')
            .then(response => {
              return response.json();
            }).then(responseJson => {
              // Get each variant that's in stock for this product
              [...sellerProductCards.getElementsByClassName('card__information')].forEach(card => {
                const cardQuantity = card.parentElement.id;
                let variantUrl;
                if (card.firstElementChild && card.firstElementChild.firstElementChild) {
                  variantUrl = card.firstElementChild.firstElementChild.href;
                }
                if (!totalCardQuantityDataList.includes(cardQuantity)) {
                  totalCardQuantityDataList.push(cardQuantity);
                  let cardQuantityDataList = cardQuantity.split("+++");
                  cardQuantityDataList = cardQuantityDataList.filter(data => data !== "");
                  [...cardQuantityDataList].forEach(cardQuantityData => {
                    cardQuantityData = cardQuantityData.split("---");
                    if (cardQuantityData.length > 0) {
                      addSellerQuantities(cardQuantityData, responseJson.items, variantUrl, country);
                    }
                  });
                }
              });
              let table = document.getElementsByTagName("table");
              if (table.length > 0) {
                // Cleanup unprocessed seller rows, for example, ones where the country does not match the current market.
                table = table[0];
                [...table.rows].forEach(sellerRow => {
                  if (!sellerRow.classList.contains("row-modifications-processed")) {
                    sellerRow.remove();
                  }
                });
                if (table.rows.length === 0) {
                  // If there's no available variants after filtering out invalid variants, set each one to unavailable., hide the div, then return
                  document.querySelector('variant-selects[id^="variant-selects-template--"]').innerHTML = "<h3>No Listings Available</h3>";
                  table.parentElement.parentElement.remove();
                  loadingSpinner.parentElement.style.textAlign = 'left';
                  globalContentLoadingDiv.classList.remove('hidden');
                  loadingSpinner.classList.add('hidden');
                  return;
                }
              }
              processSellerItems(addToCart, maxItemsInCart, responseJson);
  
              loadingSpinner.parentElement.style.textAlign = 'left';              
              globalContentLoadingDiv.classList.remove('hidden');
              loadingSpinner.classList.add('hidden');
           });
        }
  
        processSellerItems(addToCart, maxItemsInCart, responseJson) {
          const buyNowButtons = document.getElementsByClassName('wk_atc');
          [...buyNowButtons].forEach(button => {
            const main_variant_id = button.dataset.vid;
            button.style.pointerEvents = "auto";
            button.setAttribute("title", "")
            button.disabled = true;
            button.classList.add("addToCartButton");
            button.style.background = "#ab6ef8";
            button.style.border = 'none';
            button.style.cursor = "not-allowed";
            button.style.borderColor = "#ffffff"
            const filteredItems = responseJson.items.filter((item) => item.id === parseInt(main_variant_id));
            let setButtonDisabled = false;
            if (filteredItems.length > 0 && parseInt(button.dataset.quantityAvailable) === parseInt(button.dataset.totalCartQuantity)) {
              button.setAttribute("title", "You already have the maximum number of this item in your cart.");
              setButtonDisabled = true;
              button.addEventListener('onmousedown', maxItemsInCart);
              button.removeEventListener('click', addToCart);
           } else {
              button.innerText = "Add to Cart";
              button.addEventListener('click', addToCart)
           }
           let input = document.getElementsByClassName(main_variant_id)[0];
           if (input) {
              if (input.value > 0 && !setButtonDisabled) {
                button.disabled = false;
                button.style.background = "#8025F5";
                button.style.cursor = "pointer";
              }
              input.addEventListener('input', function(e) {
                const button = Array.from(document.querySelectorAll(`button[data-vid="${e.target.classList[0]}"]`))[0];
                if (parseInt(e.target.value) > 0 && parseInt(button.dataset.quantityAvailable) !== parseInt(button.dataset.totalCartQuantity)) {
                  button.disabled = false;
                  button.style.background = "#8025F5"
                  button.style.cursor = "pointer";
                } else {
                  if (parseInt(button.dataset.quantityAvailable) === parseInt(button.dataset.totalCartQuantity)) {
                    button.setAttribute("title", "You already have the maximum number of this item in your cart.");                  
                  }
                  button.disabled = true;
                  button.style.background = "#ab6ef8";
                  button.style.cursor = "not-allowed";
                }
              });
           }
          });
        };

      addSellerQuantities(sellerData, cartItems, variantUrl, country) {
          let table = document.getElementsByTagName("table");
          if (table.length > 0) {
            table = table[0];
            const rows = table.rows;
            const currentVariant = [...document.querySelectorAll('div.select option:checked')].map(variant => variant.value).join(" / ");
            const sellerDataVariant = sellerData[0];
            const sellerDataName = sellerData[1];
            const sellerDataPrice = sellerData[2].replace(/,/g, "");
            const sellerDataQuantity = sellerData[3];
            const sellerDataQuantityInt = parseInt(sellerDataQuantity);
            const variantCountry = sellerData[4];
 
            let combinedPrices = 0;
            let priceArray = []
            const totalRows = rows.length - 1; // Subtract one row for the header
            [...rows].forEach(sellerRow => {
              const sellerName = sellerRow.cells[0].innerText;
              const sellerPrice = sellerRow.cells[sellerRow.cells.length - 2].innerText;
              if (sellerPrice !== "Price") {
                  const priceFloat = parseFloat(sellerPrice.replace(/(^[\D.])/g, ''));
                  priceArray.push(priceFloat);
                  combinedPrices += priceFloat;
              }
              const rowData = [currentVariant, sellerName, sellerPrice];
              // Note: Disabling this code for now since we do not support international sales. NOTE: KEEPING AT USD FOR NOW. Canadian dollars aren't found in the webkul end, so ignore price comparision for multiple products of the same seller and variant at different prices for now.
              //const isCanadianCurrency = document.getElementsByName("country_code")[0].value === "CA";
              //const isUKCurrency = document.getElementsByName("country_code")[0].value === "UK";

              if (sellerName === sellerDataName && (sellerPrice === sellerDataPrice) && sellerDataVariant === currentVariant && sellerDataQuantityInt > 0) {
                  // If the current country does not match the current variant's seller country, do not deplay that product.
                  if (country !== variantCountry) {
                    sellerRow.remove();
                    return;
                  }
                  if (!document.getElementById("QuantityHeader")) {
                    const newHeaderCol = document.createElement('th');
                    newHeaderCol.innerText = "Quantity";
                    newHeaderCol.id = "QuantityHeader";
                    const previousHeaderCol = table.querySelector('thead > tr:first-child').cells[2];
                    previousHeaderCol.parentNode.insertBefore(newHeaderCol, previousHeaderCol);
                }
                const buttonCell = sellerRow.cells[sellerRow.cells.length - 1];
                const button = buttonCell.firstChild;
                if (!button) {
                  return;
                }
                const customDescription = sellerRow.querySelector('.caption');
                const customImage = sellerRow.querySelector('img');
                if (customDescription) {
                  if (customDescription.innerText === "undefined" || customDescription === null) {
                    customDescription.parentElement.remove();
                  }
                  customDescription.classList.remove("caption");
                  customDescription.parentElement.marginTop = '0px';
                  customDescription.parentElement.marginBottom = '0px';
                }

                if (customImage) {
                  const customImageCell = customImage.parentElement.parentElement;
                  if (customImage && true || (customImage.src === "https://www.wargametrader.com/products/undefined" || customImage.src === "https://www.wargametrader.com/products/null")) {
                    customImageCell.remove();
                  } else {
                    const link = document.createElement('a');
                    
                    link.href = variantUrl;
                    const productTitle = document.getElementsByClassName("product__title")[0].firstElementChild.innerText;
                    link.setAttribute("aria-label", `Link to Specific ${productTitle} Sold By ${sellerName} at ${sellerPrice}`);
                    customImage.style.objectFit = "cover";
                    customImage.style.maxWidth = "100px";
                    customImage.style.height = "100px";
                    customImage.alt = `Image of Specific ${productTitle} Sold By ${sellerName} at ${sellerPrice}`
                    const customImageClone = customImage.cloneNode(true);

                    const overlayDiv = document.createElement("DIV");
                    overlayDiv.classList.add('customImageOverlay');
                    overlayDiv.style.backgroundImage = `url(${customImageClone.src})`;

                    link.target = "_blank";
                    link.appendChild(customImageClone);
                    customImageClone.style.cursor = "zoom-in";

                    link.appendChild(overlayDiv);
                    
                    customImageCell.firstElementChild.appendChild(link);
                    customImage.remove();

                    // Add zoom-in overlay on image mousemove
                    customImageClone.addEventListener("mousemove", function(event) {
                        const overlay = event.target.nextElementSibling;
                        overlay.style.display = "block";
                        const img = event.target;
                        const posX = event.offsetX ? (event.offsetX) : event.pageX - img.offsetLeft;
                        const posY = event.offsetY ? (event.offsetY) : event.pageY - img.offsetTop;
                        overlay.style.backgroundPosition = (posX/overlay.offsetWidth*100) + "%" + (posY/overlay.offsetHeight*100) + "%";
                        overlay.style.backgroundSize = '102%';
                    });

                    // Hide zoom-in overlay on image mouseout                 
                    customImageClone.addEventListener("mouseout", function(event) {
                        const overlay = event.target.nextElementSibling;
                        overlay.style.display = "none";
                    });
                  }
                }
                if (button.dataset) {
                  const filteredItems = cartItems.filter((item) => item.id === parseInt(button.dataset.vid));
                  let totalCartQuantity = 0;
                  filteredItems.forEach(item => {
                    totalCartQuantity += item.quantity;
                  });
                   // If all items are in the cart, change to remove item and set the value to the max.
                  const totalQuantityLeft = totalCartQuantity === sellerDataQuantityInt ? totalCartQuantity : sellerDataQuantityInt - totalCartQuantity;
                  button.dataset.quantityAvailable = sellerDataQuantity;
                  button.dataset.totalCartQuantity = totalCartQuantity;
                  const quantityWrapperDiv = document.createElement("DIV");
                  const quantityDescription = document.createElement("p");
                  quantityDescription.innerText = ` of ${sellerDataQuantity}`;
                  quantityDescription.style.display = "inline-block";
                  quantityDescription.style.marginLeft = "10px";
                  const quantityInput = document.createElement("INPUT");
                  quantityInput.setAttribute('aria-label', 'Quantity');
                  quantityInput.name = "quantity";
                  quantityInput.setAttribute("type", "number");
                  quantityInput.setAttribute("max", totalQuantityLeft);
                  quantityInput.setAttribute("min", 1);
                  quantityInput.style.width = '30;';
                  quantityInput.value = totalCartQuantity === 0 ? 1 : totalQuantityLeft;
                  quantityInput.classList.add(button.dataset.vid);
                  quantityInput.style.display = "inline-block";
                  quantityInput.style.borderRadius = "6px";
                  quantityInput.style.padding = "5px";
                  quantityWrapperDiv.appendChild(quantityInput);
                  quantityWrapperDiv.appendChild(quantityDescription);
                  quantityWrapperDiv.style.display = "inline-block";
                  quantityWrapperDiv.style.marginRight = "10px";
                  buttonCell.insertBefore(quantityWrapperDiv, button);
                  button.style.display = "inline-block";
                  button.style.borderRadius = "6px";
                  button.style.padding = "5px";
                  quantityInput.addEventListener("input", function(event) {
                      let quantityInput = event.target;
                      let min = quantityInput.min;
                      let max = quantityInput.max;
                      let value = parseInt(quantityInput.value);
                      if (value > max) {
                          quantityInput.value = max;
                      } else if (value<min) {
                          quantityInput.value = min;
                      }
                  });
                }
                // Mark this row as successfully processed
                sellerRow.classList.add("row-modifications-processed");
              }
            });
            if (!document.getElementById("averagePrice")) {
              let average = "";
              let median = "";
              let lowest = "";
              if (totalRows > 0) {
                median = "$" + priceArray[0].toFixed(2);
                priceArray = [...priceArray].sort((a, b) => a - b);
  
                const half = Math.floor(priceArray.length / 2);
                median = "$" + (priceArray.length % 2
                  ? priceArray[half]
                  : (priceArray[half - 1] + priceArray[half]) / 2
                ).toFixed(2);
                average = "$" + ((((combinedPrices / totalRows) + Number.EPSILON) * 100) / 100).toFixed(2);
                lowest = "$" + Math.min(...priceArray).toFixed(2);
              } else {
                average = "N/A";
              }
              const aggregateListingDataDiv = document.createElement('div');
              aggregateListingDataDiv.id = "aggregateListingDataDiv";
              aggregateListingDataDiv.classList.add('aggregateListingDataDiv-flex-row');
              const lastSoldListingPlaceholder = document.getElementById("lastSoldListing");
              if (lastSoldListingPlaceholder) {
                const lastSoldListingPriceElement = document.createElement('p');
                lastSoldListingPriceElement.id = "lastSoldListingPrice";
                lastSoldListingPriceElement.innerHTML = `<span>${lastSoldListingPlaceholder.innerHTML}</span>`;
                lastSoldListingPriceElement.classList.add('aggregateListingDataDiv-flex-col');
                aggregateListingDataDiv.append(lastSoldListingPriceElement);
                lastSoldListingPlaceholder.remove();
              }
              const wk_global_div = document.getElementsByClassName("wk_global_product")[0];

              const averageElement = document.createElement('p');
              const medianElement = document.createElement('p');
              const lowestElement = document.createElement('p');
              medianElement.innerHTML = `<span><b>Median Price:</b> ${median}</span>`;
              medianElement.id = "medianPrice";
              medianElement.classList.add('aggregateListingDataDiv-flex-col');
              averageElement.innerHTML = `<span><b>Average Price:</b> ${average}</span>`;
              averageElement.id = "averagePrice";
              averageElement.classList.add('aggregateListingDataDiv-flex-col');
              lowestElement.innerHTML = `<span><b>Lowest Price:</b> ${lowest}</span>`;
              lowestElement.id = "lowestPrice";
              lowestElement.classList.add('aggregateListingDataDiv-flex-col');
              aggregateListingDataDiv.append(averageElement);
              aggregateListingDataDiv.append(medianElement);
              aggregateListingDataDiv.append(lowestElement);
              wk_global_div.prepend(aggregateListingDataDiv);
              const sellProduct = document.getElementById("sellProduct");
              if (sellProduct) {
                const sellProductLinkClone = sellProduct.cloneNode(true);
                sellProductLinkClone.style.display = "block";
                wk_global_div.prepend(sellProductLinkClone);
                sellProduct.remove();
              }
            }
          }
      }
     
    addToCart(event) {
          const button = event.target;
          if (!e) var e = window.event
          e.cancelBubble = true;
          if (e.stopPropagation) e.stopPropagation();
          const quantity = document.getElementsByClassName(button.dataset.vid)[0].value;
          button.disabled = true
          button.style.background = "#ab6ef8";
          button.style.cursor = "not-allowed";
          try {
            fetch('/cart/add.js', {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ 'items': [{ 'quantity': parseInt(quantity), 'id': button.dataset.vid }]})
           }).then(response => {
              window.location.reload();
           });
          } catch(error) {
              button.disabled = false;
              console.log(error);
          }
      }

      maxItemsInCart() {
        alert("Desired quantity not available. You already have all of these in your cart.");
      }

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
